import { useState } from "react";
import { OrderItem } from "@amzn/ito-client";

export interface ItemsTableState {
  editedValues: Record<string, Record<string, any>>;
  savingRowId: string | undefined;
  currentItemChanges: Record<string, any> | undefined;
  currentItem: OrderItem | undefined;
  pendingNoteText: string | undefined;
  pendingToken: string | undefined;
  isWaitingForUpdateResult: boolean;
}

export const useItemsTableState = () => {
  const [state, setState] = useState<ItemsTableState>({
    editedValues: {},
    savingRowId: undefined,
    currentItemChanges: undefined,
    currentItem: undefined,
    pendingNoteText: undefined,
    pendingToken: undefined,
    isWaitingForUpdateResult: false,
  });

  const updateState = (field: keyof ItemsTableState, value: any) => {
    setState((prev) => {
      if (prev[field] !== value) {
        return {
          ...prev,
          [field]: value,
        };
      }
      return prev;
    });
  };

  return { state, updateState };
};